var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.consultandoElBack } },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("h5", { staticClass: "text-center" }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.buscadorBecarios.titulo")
                      ),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-numero-apoyo",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroNumeroApoyoBecario"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-numero-apoyo" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroNumeroApoyoBecario,
                          callback: function ($$v) {
                            _vm.filtroNumeroApoyoBecario = $$v
                          },
                          expression: "filtroNumeroApoyoBecario",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-cvus-becarios",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroCvuBecarios"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-cvus-becarios" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroCvuBecarios,
                          callback: function ($$v) {
                            _vm.filtroCvuBecarios = $$v
                          },
                          expression: "filtroCvuBecarios",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-curp-becario",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroCurpBecario"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-curp-becario" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroCurpBecario,
                          callback: function ($$v) {
                            _vm.filtroCurpBecario = $$v
                          },
                          expression: "filtroCurpBecario",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-nombre-becario",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroNombreBecario"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-nombre-becario" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroNombreBecario,
                          callback: function ($$v) {
                            _vm.filtroNombreBecario = $$v
                          },
                          expression: "filtroNombreBecario",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-paterno-becario",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroApellidoPaternoBecario"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-paterno-becario" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroApellidoPaternoBecario,
                          callback: function ($$v) {
                            _vm.filtroApellidoPaternoBecario = $$v
                          },
                          expression: "filtroApellidoPaternoBecario",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-materno-becario",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroApellidoMaternoBecario"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-materno-becario" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroApellidoMaternoBecario,
                          callback: function ($$v) {
                            _vm.filtroApellidoMaternoBecario = $$v
                          },
                          expression: "filtroApellidoMaternoBecario",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  !!_vm.clavePrograma
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-for": "filtro-clave-programa",
                            label: _vm.$t(
                              "apeironGwApp.buscadorBecarios.campos.clavePrograma"
                            ),
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "filtro-clave-programa",
                              disabled: "",
                            },
                            model: {
                              value: _vm.clavePrograma,
                              callback: function ($$v) {
                                _vm.clavePrograma = $$v
                              },
                              expression: "clavePrograma",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", md: "4" } }),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-4",
                      attrs: { variant: "primary" },
                      on: { click: _vm.buscarDesdePrimerPagina },
                    },
                    [
                      _c("b-icon-search"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.buscadorBecarios.acciones.buscar"
                            )
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { staticClass: "area-responsive area-responsive-tabla" },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      bordered: "",
                      small: "",
                      "thead-class": "custom-header",
                      items: _vm.becarios,
                      fields: _vm.fieldsBecarios,
                      "show-empty": "",
                      "empty-text": _vm.$t(
                        "apeironGwApp.buscadorBecarios.mensajes.sinRegistros"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "head(checkedTabla)",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.manejarSeleccionarTodas()
                                  },
                                },
                              },
                              [_c("b-icon-check-circle")],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "cell(checkedTabla)",
                        fn: function ({ item }) {
                          return [
                            _c("b-form-checkbox", {
                              attrs: {
                                size: "lg",
                                value: true,
                                "unchecked-value": false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.manejarSeleccionarUna(item)
                                },
                              },
                              model: {
                                value: item.checkedTabla,
                                callback: function ($$v) {
                                  _vm.$set(item, "checkedTabla", $$v)
                                },
                                expression: "item.checkedTabla",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "sm",
                              id: "per-page-select",
                              options: _vm.pageOptions,
                            },
                            on: { change: _vm.buscarDesdePrimerPagina },
                            model: {
                              value: _vm.perPageBecarios,
                              callback: function ($$v) {
                                _vm.perPageBecarios = $$v
                              },
                              expression: "perPageBecarios",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "pie-tabla mt-1", attrs: { md: "8" } },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.buscadorBecarios.mensajes.registrosPorPagina"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.totalBecarios,
                      "per-page": _vm.perPageBecarios,
                      align: "fill",
                      pills: "",
                    },
                    on: { change: _vm.cambiarPagina },
                    model: {
                      value: _vm.currentPageBecarios,
                      callback: function ($$v) {
                        _vm.currentPageBecarios = $$v
                      },
                      expression: "currentPageBecarios",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-right pie-tabla mt-1",
                  attrs: { md: "4" },
                },
                [
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.totalBecarios) },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "ml-1",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.buscadorBecarios.mensajes.totalDeRegistros"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.esReadOnly
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mt-2 text-right" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.becariosSeleccionados.length < 1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.emitirSeleccion()
                            },
                          },
                        },
                        [
                          _c("b-icon-plus-circle"),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.buscadorBecarios.acciones.seleccionarBecarios"
                                )
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }